<template>

    <div class="graph__screen noselect">

        <markdown :color="'#5ea774'" :text="computedTitle" class="graph__text"></markdown>

        <div class="graph__marker-container">

            <div class="graph__marker-bloc"></div>

            <div class="graph__marker-bloc">
                <div v-show="indexMax === 1" class="graph__marker">
                    <span class="graph__marker-text">{{ maxValue }}€</span>
                </div>
            </div>

            <div class="graph__marker-bloc">
                <div v-show="indexMax === 2" class="graph__marker">
                    <span class="graph__marker-text">{{ maxValue }}€</span>
                </div>
            </div>

            <div class="graph__marker-bloc">
                <div v-show="indexMax === 3" class="graph__marker">
                    <span class="graph__marker-text">{{ maxValue }}€</span>
                </div>
            </div>

            <div class="graph__marker-bloc">
                <div v-show="indexMax === 4" class="graph__marker">
                    <span class="graph__marker-text">{{ maxValue }}€</span>
                </div>
            </div>

            <div class="graph__marker-bloc">
                <div v-show="indexMax === 5" class="graph__marker">
                    <span class="graph__marker-text">{{ maxValue }}€</span>
                </div>
            </div>

            <div class="graph__marker-bloc-last"></div>

        </div>

        <canvas id="myChart" class="graph__canvas" style="width: 105%;"></canvas>

        <div class="graph__labels-container">

            <p></p>
            <p class="graph__labels">{{ getMonth(4) }}</p>
            <p class="graph__labels">{{ getMonth(3) }}</p>
            <p class="graph__labels">{{ getMonth(2) }}</p>
            <p class="graph__labels">{{ getMonth(1) }}</p>
            <p class="graph__labels">{{ getMonth(0) }}</p>
            <p></p>

        </div>

    </div>


</template>

<script>

import Chart from 'chart.js'

import Markdown from '@/components/Markdown'

import I18n from '@/modules/i18n'

export default {

    name: 'graphic',

    components: {Markdown},

    props: {

        data: {
            type: Object,
            default: () => {
            }
        }
    },

    computed: {

        computedTitle: function () {
            return this.$tc('stories_screen_5_text', 0, {amount: this.computedAverage, currency: this.data.value.currencySymbol})
        },

        computedAverage: function () {
            const sum = this.data.value.expenses.map(item => item.amount).reduce((acc, cur) => acc + cur)
            const average = Math.round(sum / 5)
            return average
        }
    },

    data() {
        return {
            indexMax: -1,
            maxValue: -1,
            graphData: {
                labels: ['', '', '', '', '', '', ''],
                datasets: [{
                    label: 'Filled',
                    borderColor: 'rgb(94 167 116)',
                    data: [],
                    pointRadius: [1, 1, 1, 5, 1, 1, 1]
                }]
            },
            options: {
                animation: {
                    duration: 0
                },
                scales: {
                    yAxes: [{
                        display: false,
                        ticks: {
                            display: false
                        },
                        labels: {
                            fontColor: 'rgb(196, 212, 201)'
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            drawBorder: false,
                            color: ['rgba(196, 212, 201, 0.1)', 'rgba(196, 212, 201, 0.1)', 'rgba(196, 212, 201, 0.1)', 'rgba(196, 212, 201, 0.1)', 'rgba(196, 212, 201, 0.1)', 'rgba(196, 212, 201, 0.1)', 'rgba(196, 212, 201, 0.1)']
                        }
                    }]
                },
                legend: {
                    display: false
                },
                responsive: false,
                elements: {
                    point: {
                        backgroundColor: '#5ea774'
                    }
                }
            }
        }
    },

    mounted() {

        const arrayData = this.getDataArray()

        this.initGraphData(arrayData)

        const ctx = document.getElementById('myChart').getContext('2d')
        new Chart(ctx, {
            type: 'line',
            data: this.graphData,
            options: this.options
        })
    },

    methods: {

        getMonth(index) {

            const monthNumber = this.data.value.expenses[index].month

            const date = new Date()

            date.setMonth(monthNumber - 1)

            const month = date.toLocaleString(I18n.get(this), {month: 'short'})

            return month.charAt(0).toUpperCase() + month.slice(1)

        },

        getDataArray() {

            const reverseData = [...this.data.value.expenses].reverse()

            const dataArray = reverseData.map(month => month.amount)

            dataArray.push(dataArray[dataArray.length - 1])
            dataArray.unshift(dataArray[0])

            return dataArray
        },

        initGraphData(arrayData) {

            // set data
            this.graphData.datasets[0].data = arrayData

            //set point size
            const pointArray = arrayData.map((value, index) => {

                const element = parseInt(value, 10)
                if (element > this.maxValue) {
                    this.maxValue = element
                    this.indexMax = index
                }
                return '1'
            })

            if (this.indexMax === 0) {
                this.indexMax = 1
            }

            pointArray[this.indexMax] = '5'

            this.graphData.datasets[0].pointRadius = pointArray
        }

    }

}

</script>

<style lang="scss" scoped>

.graph {
    &__screen {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        background-color: $rifle;
        align-items: center;
        justify-content: space-between;
        padding-top: 98px;
    }

    &__text {
        font-size: 22px;
        color: $sand;
        margin: 0 24px;
        text-align: center;
        font-weight: bold;
    }

    &__canvas {
        width: 105%;
        height: 290px;
    }

    &__marker-container {
        display: flex;
        flex-grow: 1;
        align-items: flex-end;
        width: 100%;
        justify-content: space-between;
    }

    &__marker-bloc {
        width: 48px;
    }

    &__marker-bloc-last {
        width: 0;
    }

    &__marker {
        width: 48px;
        height: 53px;
        background-image: url('/img/stories/background@3x.png');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 48px auto;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: -24px;
        position: relative;
        z-index: 1;
    }

    &__marker-text {
        font-size: 13px;
        font-weight: bold;
        color: $rifle;
    }

    &__labels-container {
        position: fixed;
        bottom: 16px;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    &__labels {
        font-size: 12px;
        font-weight: bold;
        color: $mint;
    }
}

</style>

